
/**
 * 按钮点击回调
 */
export const clickHander: any = {
    'measure-distance' : (item: any, params: any) => {
       params.toolComponent.measureLength();
    },
    'measure-area': (item: any, params: any) => {
        params.toolComponent.measureArea();
    },
    'clear': (item: any, params: any) => {
        params.toolComponent.clearAll();
    },
    'full-screen': (item: any, params: any) => {
        if (item.selected) {
            params.toolComponent.fullScreen('app');
        } else {
            params.toolComponent.exitFullScreen('app');
        }
    },
    'full-extent': (item: any, params: any) => {
        params.toolComponent.fullExtent();
    },
    'screen-shot': (item: any, params: any) => {
        params.toolComponent.screenShot();
    },
    'plot' : (item: any, params: any) => {
        params.context.showPlot();
    },
    'typhoon' : (item: any, params: any) => {
        params.toolComponent.showTyphoon();
    },
    'thematic': (item: any, params: any) => {
        // 专题图
        params.context.isShowThematic = true;
    },
    'router': (item: any, params: any) => {
        // 路径规划
    },
    'realtime-traffic': (item: any, params: any) => {
        if (item.selected) {
            params.toolComponent.addTafficLayer();
            params.context.isShowTraffic = true;
        } else {
            params.toolComponent.removeTrfficLayer();
            params.context.isShowTraffic = false;
        }
    },
    'map-print': (item: any, params: any) => {
    },
    'typhoon-track': (item: any, params: any) => {
        // 台风路径
    },
    'nearby': (item: any, params: any) => {
        // 周边查询
    },
    'pano-baidu': (item: any, params: any) => {
        if (item.selected) {
            params.toolComponent.addbdLayerCtol();
        } else {
            params.toolComponent.removebduLayerCtro();
        }
    },
    'pano-tencent': (item: any, params: any) => {
        if (item.selected) {
            params.toolComponent.addTencentLayerCtol();
        } else {
            params.toolComponent.removeTencentLayerCtro();
        }
    },
};

